import {
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { t } from 'i18next';
import { FC, ReactNode } from 'react';
import useBaseLinks from 'store/Auth/Links/useBaseLinks';
import { useGetLanguagesQuery } from 'store/_Api/Users';
import Languages from './Languages.json';
import borders from 'style/border-vars.module.scss';

import './LanguageSelect.scss';

type PropsType = {
  value?: string;
  handleChange: (event: SelectChangeEvent<string>, child: ReactNode) => void;
};

const LanguageSelect: FC<PropsType> = ({
  value = 'en',
  handleChange,
}): JSX.Element => {
  const { getLink } = useBaseLinks();
  const getLanguageLink = getLink('languages') ?? '';
  const { data } = useGetLanguagesQuery(getLanguageLink);

  return (
    <Grid display="flex" alignItems="center">
      <Typography marginRight={'18px'}>{t('Language') + ':'} </Typography>

      <Select
        fullWidth
        value={value}
        onChange={handleChange}
        size="small"
        name="language"
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            border: borders.normalBlack,
          },
        }}
      >
        {data?.collection?.map((languageCode) => (
          <MenuItem value={languageCode} key={languageCode}>
            {Languages[languageCode] ?? 'N/A'}
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
};

export default LanguageSelect;
